module.exports = __webpack_public_path__ + "static/sb2-c9fca8b40cec89be9e7fbba38427adc4.jpg";